// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__iKU0z","errorLogs":"styles_errorLogs__5o-QO"};